module.exports = __webpack_public_path__ + "img/fatherhood_1.a77cfbe9.jpg";